import { InView } from 'react-intersection-observer';

const displayScrollItem = (inView, entry) => {
    if (inView) {
        entry.target.classList.add('isShow');
        entry.target.classList.add('glitchPattern01');
    } else {
        entry.target.classList.remove('isShow');
        entry.target.classList.remove('glitchPattern01');
    }
}

export default function ScrollItem({ children }) {
    return (
        <InView as="div" className="scrollItem" onChange={(inView, entry) => displayScrollItem(inView, entry)}>
            {children}
        </InView>
    )
}